<template>
  <v-container fluid>
    <base-material-card color="primary" icon="mdi-barcode-scan" inline class="ml-0 px-5 py-4">
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">Cálculo de Banco de Preços</div>
      </template>
      <v-btn
        id="btn-novo-calculo-bp"
        color="success"
        dark
        elevation="1"
        class="mt-5"
        style="float: left"
        relative
        text
        medium
        @click="$router.push('edit')"
      >
        <v-icon left size="30px">mdi-plus-circle</v-icon>
        Novo Cálculo de BP
      </v-btn>
      <v-text-field
        id="calculo-bp-search"
        v-model="search"
        append-icon="mdi-magnify"
        class="break-search bs-banco-precos ml-auto mt-4"
        label="Procurar"
        hide-details
        single-line
        style="max-width: 250px"
      />
      <general-progress-bars class="mt-11" :items="downloadProgressData" prefix-text="Baixando Cálculo de banco de Preços" />
      <v-divider class="mt-10" />
      <v-data-table
        class="banco-precos-table"
        :headers="headers"
        :items="items"
        :search.sync="search"
        :header-props="{
          sortByText: 'Ordenar Por'
        }"
        :footer-props="{
          itemsPerPageText: 'Itens por Página'
        }"
        no-data-text="Nenhum cálculo de banco de preço disponível"
        no-results-text="Nenhum registro correspondente encontrado"
        mobile-breakpoint="800"
        :loading="loading"
      >
        <template v-slot:[`item.id`]="{ item }">
          {{ item.id }}
        </template>
        <template v-slot:[`item.titulo`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div
                v-bind="attrs"
                class="text-truncate-column"
                :class="['EXECUTANDO', 'AGUARDANDO'].includes(item.status) ? 'clickable-item' : ''"
                v-on="on"
                @click="openModalAcompanhamento(item)"
              >
                {{ item.titulo }}
              </div>
            </template>
            <span>{{ item.titulo }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.usuario`]="{ item }">
          {{ item.usuario }}
        </template>
        <template v-slot:[`item.data_processamento`]="{ item }">
          {{ item.data_processamento }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <general-status :status="item.status" />
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            id="action-download-calculo-bp"
            :class="item.status != 'SUCESSO' ? 'cursor-block' : ''"
            :disabled="item.status != 'SUCESSO'"
            min-width="0"
            class="px-1"
            fab
            icon
            x-small
            :loading="downloadProgressData[item.id] !== undefined ? true : false"
            @click="downloadItem(item, item.titulo)"
          >
            <v-icon small>mdi-download</v-icon>
          </v-btn>
          <v-btn
            id="action-edit-calculo-bp"
            :class="!canEditItem(item) ? 'cursor-block' : ''"
            :disabled="!canEditItem(item)"
            min-width="0"
            class="ml-n1 px-1"
            fab
            icon
            x-small
            @click="$router.push(`edit/${item.id}`)"
          >
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                id="action-more-calculo-bp"
                color="white"
                class="ml-1"
                height="22px"
                width="22px"
                fab
                x-small
                elevation="1"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small>mdi mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-if="canRunItem(item)" @click="executar(item.id)">
                <v-list-item-title>
                  <v-icon small>mdi-play</v-icon>
                  Executar
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="duplicar(item.id)">
                <v-list-item-title>
                  <v-icon small>mdi-content-copy</v-icon>
                  Duplicar
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="canDeleteItem(item)" @click="openDialogDelete(item.id, item.titulo)">
                <v-list-item-title>
                  <v-icon small>mdi-trash-can-outline</v-icon>
                  Deletar
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="openDialogDetalhes(item)">
                <v-list-item-title>
                  <v-icon small>mdi-file-find-outline</v-icon>
                  Detalhes
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:[`footer`]>
          <v-switch
            v-if="$store.getters.userIsAdmin"
            class="pa-0 pl-2 swithInterna"
            style="position: absolute"
            color="primary"
            label="Exibir Expirados"
            dense
            @change="$emit('switchProcessamentosExpirados', $event)"
          />
        </template>
      </v-data-table>
    </base-material-card>
    <dialog-delete
      :show-dialog="dialogDelete"
      @changeValue="dialogDelete = $event"
      @deleteTriggered="excluir(dialogDeleteData.id)"
    >
      <template slot="title">Deletar Cálculo de BP #{{ dialogDeleteData.id }}</template>
      <template slot="body">
        Tem certeza que deseja deletar o cálculo de banco de preços
        <strong>{{ dialogDeleteData.titulo }}</strong>
        ?
      </template>
    </dialog-delete>
    <general-dialog-detalhes
      ref="dialogDetalhes"
      title="Detalhes do Cálculo de BP"
      :show-dialog="dialogDetalhes"
      @changeValue="dialogDetalhes = $event"
    >
      <template slot="body">
        <v-data-table
          :headers="[
            { text: 'Parâmetro', value: 'parametro', sortable: false },
            { text: 'Valor', value: 'valor', sortable: false }
          ]"
          :items="dialogDetalhesData"
          hide-default-footer
          class="elevation-1 style-table-dialog-detalhes"
          disable-pagination
          mobile-breakpoint="0"
        >
          <template v-slot:item="row">
            <tr>
              <td class="button">
                {{ row.item.parametro }}
              </td>
              <td class="button">
                {{ row.item.valor }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </template>
    </general-dialog-detalhes>
    <general-dialog-acompanhamento
      ref="dialogAcompanhamento"
      :show-dialog="dialogAcompanhamento"
      :messages="dialogAcompanhamentoData.andamento"
      :name-event-pusher="'andamento-calculo-banco-precos-' + dialogAcompanhamentoData.id"
      @changeValue="dialogAcompanhamento = $event"
    >
      <template slot="title">Andamento do Cálculo de BP #{{ dialogAcompanhamentoData.id }}</template>
    </general-dialog-acompanhamento>
  </v-container>
</template>

<script>
  import BancoPrecosService from '@/services/BancoPrecosCalculosService';
  import powerupsActionsMixins from '@/mixins/powerupsActionsMixins.js';

  export default {
    components: {
      DialogDelete: () => import('@/components/general/DialogDelete'),
      GeneralDialogAcompanhamento: () => import('@/components/general/GeneralDialogAcompanhamento'),
      GeneralProgressBars: () => import('@/components/general/GeneralProgressBars.vue'),
      GeneralStatus: () => import('@/components/general/GeneralStatus.vue'),
      GeneralDialogDetalhes: () => import('@/components/general/GeneralDialogDetalhes')
    },
    mixins: [powerupsActionsMixins],

    props: {
      items: {
        type: Array,
        default: () => []
      },
      loading: {
        type: Boolean,
        default: false
      }
    },

    emits: ['switchProcessamentosExpirados', 'recharge'],

    data() {
      return {
        powerupService: BancoPrecosService,
        powerupEntityName: 'Cálculo de Banco de Preços',
        dialogDelete: false,
        dialogDeleteData: { id: undefined, titulo: undefined },
        dialogDetalhes: false,
        dialogDetalhesData: [],
        search: '',
        headers: [
          {
            text: '#',
            value: 'id'
          },
          {
            text: 'Título',
            value: 'titulo'
          },
          {
            text: 'Usuário',
            value: 'usuario'
          },
          {
            text: 'Executado',
            value: 'data_processamento'
          },
          {
            text: 'Status',
            value: 'status'
          },
          {
            sortable: false,
            text: 'Ações',
            value: 'actions',
            class: 'pl-4'
          }
        ],
        bancoPrecos: [],
        downloadProgressData: {},
        dialogAcompanhamento: false,
        dialogAcompanhamentoData: { id: undefined, andamento: [] }
      };
    },

    computed: {
      user() {
        return this.$store.getters.getUser;
      }
    },

    methods: {
      executar(id) {
        BancoPrecosService.executar(id)
          .then(() => {
            this.$toast.success('Sua planilha será gerada em instantes. Por favor, aguarde.', '', { position: 'topRight' });
            this.$emit('recharge');
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao executar cálculo de banco de preços.', '', { position: 'topRight' });
          });
      },

      duplicar(id) {
        BancoPrecosService.duplicar(id)
          .then(() => {
            this.$toast.success('Cálculo de banco de preços duplicado com sucesso.', '', { position: 'topRight' });
            this.$emit('recharge');
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao duplicar cálculo de banco de preços.', '', { position: 'topRight' });
          });
      },

      excluir(id) {
        BancoPrecosService.excluir(id)
          .then(() => {
            this.$toast.success('Cálculo de banco de preços excluido com sucesso.', '', { position: 'topRight' });
            this.$emit('recharge');
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao excluir cálculo de banco de preços.', '', { position: 'topRight' });
          });

        this.dialogDelete = false;
      },

      openDialogDelete(id, titulo) {
        this.dialogDeleteData = { id: id, titulo: titulo };
        this.dialogDelete = true;
      },

      openDialogDetalhes(bancoPrecos) {
        this.dialogDetalhesData = [
          {
            parametro: 'DATA INÍCIAL:',
            valor: bancoPrecos.data_inicial
          },
          {
            parametro: 'DATA FINAL',
            valor: bancoPrecos.data_final
          },
          {
            parametro: 'DATA BASE',
            valor: bancoPrecos.data_base
          }
        ];

        this.dialogDetalhes = true;
      },

      openModalAcompanhamento(bancoPrecos) {
        if (!['EXECUTANDO', 'AGUARDANDO'].includes(bancoPrecos.status)) {
          return;
        }
        this.dialogAcompanhamentoData.id = bancoPrecos.id;
        this.dialogAcompanhamento = true;

        this.attAndamento(bancoPrecos.id);
      },

      attAndamento(id) {
        BancoPrecosService.andamento(id)
          .then((response) => {
            this.dialogAcompanhamentoData.andamento = response.data.andamento;
            this.$refs.dialogAcompanhamento.activatePusher();
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao recuperar andamento do cálculo de banco de preços.', '', { position: 'topRight' });
          });
      }
    }
  };
</script>

<style>
  @media screen and (min-width: 800px) {
    .banco-precos-table table tr td:nth-child(2) {
      max-width: 200px;
    }

    .banco-precos-table table tr td:nth-child(5),
    .banco-precos-table table tr td:nth-child(6) {
      white-space: nowrap !important;
    }
  }

  @media screen and (max-width: 480px) {
    .bs-banco-precos {
      min-width: 223.69px !important;
    }
  }

  .swithInterna label {
    font-size: 13px !important;
    margin-left: 0px !important;
  }
</style>